<template>

    <div>
        <!-- 프로젝트 상태 -->

        <!-- IT프로 회원 (IT프로 본인의 프로젝트 참여 상태), 관리자에서 IT프로의 프로젝트 상세 조회시 -->
        <div v-if="type == '1' || type == '5'" class="show-box prj">
            <div v-if="projectInfo.projectRecrStatus == '1' && projectInfo.interviewStatusCd == '04'" class="state-mark pf">참여중</div>
            <div v-else-if="projectInfo.projectRecrStatus == '2' && projectInfo.interviewStatusCd == '04'" class="state-mark pf_ep">참여예정</div>
            <div v-else-if="projectInfo.projectRecrStatus == '9' && projectInfo.interviewStatusCd == '04'" class="state-mark pf cp">참여완료</div>

            <nbsp/>
            <div v-if="projectInfo.recrStartYyyymmdd <= nowYyyymmdd && projectInfo.recrEndYyyymmdd >= nowYyyymmdd" class="state-mark ep">모집중</div>
            <div v-else class="state-mark pf cp">모집마감</div>

            <div class="date">
                <div class="dead" v-if="recrCloseYn != 'Y'">
                    모집마감일 
                    <template>
                        {{projectInfo.recrEndYyyymmdd | date('yyyy.MM.dd')}}
                    </template>
                </div>
                <div>
                    등록일 {{projectInfo.regYyyymmdd}}
                </div>
            </div>
        </div>

        <!-- 클라이언트 총괄관리자, 프로젝트 담당자, 관리자 (프로젝트 수행 상태) -->
        <div v-else-if="type == '2' || type == '3' || type == '101' || type == '104' "  class="show-box prj">
            <div v-if="projectInfo.projectStatus == '1'" class="state-mark pf">수행중</div>
            <div v-else-if="projectInfo.projectStatus == '2'" class="state-mark pf_ep">수행예정</div>
            <div v-else-if="projectInfo.projectStatus == '9'" class="state-mark pf cp">수행완료</div>	

            <!-- 클라이언트 프로젝트 담당자 & 총괄관리자 일때 모집중 표시 -->
            <nbsp/>
            <div v-if="(type == '3' || type == '2' || type == '101' || type == '104') && (projectInfo.apprYn == 'N')" class="state-mark no">미승인</div>
            <div v-else-if="(type == '3' || type == '2' || type == '101' || type == '104') && (projectInfo.recrStartYyyymmdd <= nowYyyymmdd && projectInfo.recrEndYyyymmdd >= nowYyyymmdd)" class="state-mark ep">모집중</div>
           
            <div v-if="(type == '101' || type == '104')" class="state-mark" style="width: 220px; float: right;">프로젝트 일련번호 : {{projectInfo.projectSeq}}</div>       

            <div class="date">
                <div class="dead" v-if="recrCloseYn != 'Y'">
                    모집마감일 
                    <template>
                        {{projectInfo.recrEndYyyymmdd | date('yyyy.MM.dd')}}
                    </template>
                </div>
                <div>
                    등록일 {{projectInfo.regYyyymmdd}}
                </div>
            </div>
        </div>

        <!-- 파트너사 프로젝트 현황의 프로젝스 상세 - IT프로 회원의 참여상태 표시 -->
        <div v-if="type == '4'" class="show-box prj">
            <div v-if="projectInfo.projectStatus == '1'" class="state-mark pf">참여중</div>
            <div v-else-if="projectInfo.projectStatus == '2'" class="state-mark pf_ep">참여예정</div>
            <div v-else-if="projectInfo.projectStatus == '9'" class="state-mark pf cp">참여완료</div>

            <nbsp/><div v-if="projectInfo.recrStartYyyymmdd <= nowYyyymmdd && projectInfo.recrEndYyyymmdd >= nowYyyymmdd" class="state-mark ep">모집 중</div>
            
            <div class="date">
                <div class="dead" v-if="recrCloseYn != 'Y'">
                    모집마감일 
                    <template>
                        {{projectInfo.recrEndYyyymmdd | date('yyyy.MM.dd')}}
                    </template>
                </div>
                <div>
                    등록일 {{projectInfo.regYyyymmdd}}
                </div>
            </div>
        </div>      
        
        <!-- 클라이언트/파트너사  프로젝트 지원/인터뷰 현황의 프로젝스 상세 - 프로젝트 상태 표시 -->
        <div v-if="type == '6' || type == '7' || type == '102' || type == '103'" class="show-box prj">
            <div v-if="projectInfo.projectStatus == '1'" class="state-mark pf">수행중</div>
            <div v-else-if="projectInfo.projectStatus == '2'" class="state-mark pf_ep">수행예정</div>
            <div v-else-if="projectInfo.projectStatus == '9'" class="state-mark pf cp">완료</div>

            <nbsp/><div v-if="projectInfo.recrStartYyyymmdd <= nowYyyymmdd && projectInfo.recrEndYyyymmdd >= nowYyyymmdd" class="state-mark ep">모집 중</div>
            <div v-else class="state-mark pf cp">모집완료</div>

            <div class="date">
                <div class="dead" v-if="recrCloseYn != 'Y'">
                    모집마감일 
                    <template>
                        {{projectInfo.recrEndYyyymmdd | date('yyyy.MM.dd')}}
                    </template>
                </div>
                <div>
                    등록일 {{projectInfo.regYyyymmdd}}
                </div>
            </div>
        </div>

        <!-- 프로젝트명 -->
        <div class="prj_outline">
            <div class="name">
                <div class="value name">{{projectInfo.projectNm}}</div>
            </div>

            <div class="outline">
                <div class="label">
                    <p>개 요</p>
                </div>
                <div class="value multiText">
                    {{projectInfo.projectDtlDesc}}
                </div>
            </div>

            <div class="outline">
                <div class="label">
                    <p>고 객 사</p>
                </div>
                <div class="value">
                    {{projectInfo.clientNm}}                    
                </div>                
            </div>

            <div class="outline">
                <div class="label">
                    <p>산 업 분 야</p>
                </div>
                <div class="value">
                    <SelectComp type="text" cdId="PRO105" :value="projectInfo.projectIndtype"/> 
                    / 
                    <SelectComp type="text" cdId="PRO143" :value="projectInfo.projectIndtypeClassCd"/>
                </div>
            </div>

            <!-- <div class="date">
                <div class="label">등록일자</div>
                <div class="value">{{projectInfo.regYyyymmdd}}</div>
            </div>
            
            <div class="date">
                <div class="label">모집마감일</div>
                <div class="value">
                    <template v-if="recrCloseYn != 'Y'">
                        {{projectInfo.recrEndYyyymmdd | date('yyyy.MM.dd')}}
                    </template>
                    <div v-else class="deadline-text">모집마감</div>
                </div>
            </div> -->

            <!-- <div class="btn-box">
                <div class="btn">
                    <div class="ci_box">
                        <ImageComp type="image" :src="'/api/prj/tec/projectCorpImg?projectSeq='+projectInfo.projectSeq" defaultSrc="COMPANY" alt="고객사 로고"/>
                    </div>
                </div>                
            </div> -->
        </div>

        <!-- 프로젝트 개요 -->      
        <div class="prj_outline">
            <div class="outline">
                <div class="label">
                    <p>수 행 사</p>
                </div>
                <div class="value">
                    <span>{{projectInfo.corpNm}}</span>
                </div>
            </div>

            <div class="outline">
                <div class="label">
                    <p>근 무 지</p>
                </div>
                <div class="value">{{projectInfo.projectLocCont}}</div>
            </div>

            <!-- <div class="outline">
                <div class="label">담당자</div>
                <div v-if="projectInfo.corpMgrMberNm" class="value">{{projectInfo.corpMgrMberNm}}</div>
                <div v-else class="value">-</div>

                <div v-if="type == 2" class="change" @click="clickChangeCorpMgrMberNm()">변경 <div class="triangle"></div></div>
                <div v-if="type >= 100 && $store.state.userInfo.mberDivCd == '00'" class="change" @click="clickChangeCorpMgrMberNmAdm()">담당자 교체 &#9654;</div>
            </div> -->

            <div class="outline">
                <div class="label">
                    <p>개 발 기 간</p>
                </div>
                <div class="value">{{projectInfo.projectStartEndYyyymmdd}}</div>
            </div>
            
            <!-- 모집마감 및 지원자 현황은 관리자만 표시 (사용자 : 사이드박스에 표시)-->
            <!-- IT프로, 클라이언트 총관관리자, 파트너사 -->
            <!-- <div v-if="type == '1' || type == '2' || type == '4'" class="btn-box notice">
                <div class="btn" v-if="projectInfo.recrEndDateDiff >= 0">
                    <img src="/images/tec/prj/date.png" alt="모집마감일"/>
                    모집 마감 <span class="num">{{projectInfo.recrEndDateDiff}}</span>일 전
                </div>
                <div class="btn">
                    <img src="/images/tec/prj/member_sm.png" alt="프로젝트 참여자수"/>
                    프로젝트 참여 <span class="num">{{projectInfo.mberCnt}}명</span>
                </div>
            </div> -->
            <!-- 클라이언트 프로젝트 담당자, IT프로 프로젝트 찾기, 관리자 -->
            <!-- <div v-if="type == '3' || type == '5' || type == '103' || type == '104'" class="btn-box notice"> -->
            <!-- <div v-if="type == '103' || type == '104'" class="btn-box notice">
                <div class="btn" v-if="projectInfo.recrEndDateDiff >= 0">
                    <img src="/images/tec/prj/date.png" alt="모집마감일"/>
                    모집 마감 <span class="num">{{projectInfo.recrEndDateDiff}}</span>일 전
                </div>
                <div class="btn" v-if="type < 100 && projectInfo.projectStatus != '9' && projectInfo.recrEndDateDiff >= 0" >
                    <img src="/images/tec/prj/member_sm.png" alt="지원자수"/>
                    지원자 <span class="num">{{projectInfo.appCount}}</span>명
                </div>

                <div v-if="type == '3' && isScoPrj" class="btn member" style="margin-left : 10px">
                    <img src="/images/btn_frame.png" alt="멤버수"/>
                    <div class="number">
                        <div class="cnt-box"><p class="title ivl21">합격</p><p class="person">{{projectInfo.mberCnt}}명</p></div>  
                        <div class="cnt-box"><p class="title">불합격</p><p class="person">{{projectInfo.mberCntFail}}명</p></div> 
                    </div>
                </div>
                
                <div class="btn member" v-if="type == '103' || type == '104'" style="margin-left : 10px">
                    <img src="/images/btn_member.png" alt="멤버수"/>
                    <div class="number">
                        <p>{{projectInfo.passMberCnt}}명</p> 투입 제외 합격
                        <p>{{projectInfo.mberCntFail}}명</p>  불합격
                        <p>{{projectInfo.mberCntInterview}}명</p>  인터뷰
                        <p>{{projectInfo.inputMberCnt}}명</p> 투입
                    </div>
                </div>
            </div> -->

            <!-- 관리자 -->
            <!-- <div v-if="type == '101' || type == '102'" class="btn-box notice">
                <div class="btn" v-if="projectInfo.recrEndDateDiff >= 0"><img src="/images/tec/prj/date.png" alt="모집마감일"/><p>모집 마감 <span class="num">{{projectInfo.recrEndDateDiff}}</span>일 전</p></div>
                <div class="btn">
                    <img src="/images/prj_member.png">
                    <p>참여 IT프로 <span class="num">{{projectInfo.mberCnt}}</span>명</p>
                </div>
            </div> -->
        </div>

        <!-- 프로젝트 직무분야 -->
        <div class="prj_outline">
            <div class="outline">
                <div class="label">
                    <p>직 무 분 야</p>
                </div>
                <div class="value">
                    <div class="dutyList">
                        <span class="dutyitem" v-for="(duty, index) in projectInfo.dutyFieldList" :key="index">
                            <SelectComp type="text_comma_split" cdId="PRO141" :value="duty.dutyFilter"/> / <SelectComp type="text_comma_split" cdId="PRO142" :value="duty.dutyDetail"/>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 프로젝트 모집내용 -->
        <div class="prj_outline">
            <div class="outline">
                <div class="label">
                    <p>개 발 기 술</p>
                </div>
                <div class="value multiText">{{projectInfo.devTechCont}}</div>
            </div>

            <!-- 모집분야 인원자격 -->
            <div v-if="isBlur" style="position: relative;">
                <div v-for="index in 3" :key="index" class="outline ranking">
                    <div :class="index == 1 ? 'label qlif' : 'label qlif hide'">
                        <p>모 집 분 야</p>
                        <p>인 원 / 자 격</p>
                    </div>
                    <div class="value ranking_tit filter-b">&#9660; <span class="mem">개발 : 00명</span>
                        &lt; 모집기간 : <span class="period">0000.00.00 - 0000.00.00</span> &gt;
                    </div><br/>
                    <div class="value ranking filter-b">
                        <div class="level">기술등급 <span class="lev">-</span></div>
                        <div class="career">경력 <span class="cre">-</span></div>
                        <div class="period">참여기간 <span class="prd pr-40">-</span></div>
                    </div>
                </div>
                <div class="notice_popup login_move">
                    <div class="txt pt-6">
                        IT프로 로그인 후 <br />
                        전체 내용을 확인하실 수 있습니다.
                    </div>
                    <div class="login_btn">
                        <div style="width:300px; height:50px;" @click="pageMove()">로그인/회원가입</div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-for="(recr, index) in projectRecrFieldList" :key="recr.projectRecrFieldSeq" class="outline ranking">
                    <div :class="index == 0 ? 'label qlif' : 'label qlif hide'">
                        <p>모 집 분 야</p>
                        <p>인 원 / 자 격</p>
                    </div>
                    <div class="value ranking_tit">&#9660; <span class="mem">{{recr.workCont}} : {{recr.persCnt}}명 </span>
                        &lt; 모집기간 : <span class="period">{{recr.projectRecrStartEndYyyymmdd}}</span> &gt;
                    </div><br/>
                    <div class="value ranking">
                        <div class="level">기술등급 <span class="lev"><SelectComp type="text" cdId="PRO106" :value="recr.techGradeCd"/></span></div>
                        <div class="career">경력 <span class="cre"><SelectComp type="text" cdId="PRO107" :value="recr.careerTermCd"/></span></div>
                        <div class="period">참여기간 <span class="prd">{{recr.projectJoinStartEndYyyymmdd}}</span></div>
                        
                        <!-- 관리자가 아닐때 -->
                        <div v-if="type < 100 && (recr.recrEndYn == 'Y' || recr.recrTermEndYyyymmdd < nowYyyymmdd)" class="deadline-text">모집마감</div>
                        <!--// -->

                        <!-- 관리자 -->
                        <div v-if="type >= 100 && (recr.recrEndYn == 'Y' || recr.recrTermEndYyyymmdd < nowYyyymmdd)" class="deadline-text ep" @click="admRecrEnd(1, recr.recrEndYn, recr.projectRecrFieldSeq, recr.workCont, recr.projectRecrStartEndYyyymmdd)">모집마감</div>
                        <div v-else-if="type >= 100 && editable" class="deadline-text change" @click="admRecrEnd(2, recr.recrEndYn, recr.projectRecrFieldSeq, recr.workCont, recr.projectRecrStartEndYyyymmdd)">모집마감으로 변경 &#9654;</div>
                        <!--//  -->
                    </div>
                </div>
            </div>
        </div>

        <!-- 매니저 -->
        <!-- <div class="prj_outline agent">
            <div class="outline">
                <div class="label">매니저</div>
                <div v-if="projectInfo.admMgrMberNm" class="value">{{projectInfo.admMgrMberNm}}</div>
                <div v-else class="value">-</div>
                <template v-if="$store.state.userInfo.mberDivCd == '00'">
                    <div v-if="projectInfo.admMgrMberNm" class="change" @click="clickChangeAgent('mod')">매니저 변경 &#9654;</div>
                    <div v-else class="change" @click="clickChangeAgent('new')">매니저 배정 &#9654;</div>
                </template>
            </div>
        </div>         -->

        <!-- 업무내용 -->
        <div class="prj_outline last">
            <div class="outline">
                <div class="label">
                    <p>업 무 내 용</p>
                </div>
                <div v-if="isBlur" tagName="div" class="busi_inform filter-b">
                    프로젝트 소개<br/>
							- 발주사 : OO은행<br/><br/>
							프로젝트 진행 상황<br/>
							- 요구사항 분석 또는 설계 문서가 있습니다.<br/><br/>
							전체 시스템 구성<br/>
							- OO의 개발 플랫폼(mquics) 을 사용합니다. ( 프레임워크에 대한 개발 가이드 제공 )<br/><br/>
							전체 프로젝트 일정 <br/>
							- 사업 일정 : 21년 8월초 착수함<br/>
							- 개발 착수 일정 : 21년 8월 초순 (투입 마감 일정 : 8월말, 착수 일정은 8월 초순 ~ 8월말 사이에서 조율 가능)<br/>
							- 개발 종료 일정 : 22년 3월 중순<br/><br/>
							&lt; 상세 업무 내용 &gt; <br/>
							모집 인원 : 프론트엔드 개발 10명<br/>
							- 분석/설계 1명<br/>
							- 개발 8명<br/>
							- Sub 개발 1명<br/>
                </div>
                <nbsp v-else tagName="div" class="busi_inform" :value="projectInfo.projectWorkCont"/>                    
            </div>
        </div>
        
    </div>
</template>

<script>

/**
 * props :
 *          type : 
 *                  1 - IT프로 회원 내프로젝트의 프로젝트 상세 팝업
 *                  2 - 클라이언트 총괄관리자 전체프로젝트의 프로젝트 상세
 *                  3 - 클라이언트 프로젝트 담당자 내프로젝트의 프로젝트 상세
 *                  4 - 파트너사 프로젝트현황의 프로젝트 상태 (프로젝트 참여상태 코드를 props로 받아서 표시함)
 *                  5 - IT프로 프로젝트찾기의 프로젝트 상세 팝업
 * 
 *                  101 - 관리자 회원관리 > 클라이언트 > 클라이언트 정보관리 > 프로젝트 목록 > 프로젝트 상세
 *                  102 - 관리자 회원관리 > IT프로 > IT프로 최종 정보 관리 > IT프로 종합정보 > 참여중인 프로젝트 > 프로젝트 상세보기
 *                  103 - 관리자 회원관리 > IT프로 > IT프로 최종 정보 관리 > IT프로 종합정보 > 참여예정 프로젝트 > 프로젝트 상세보기
 *                  104 - 관리자 프로젝트관리 > 전체프로젝트 > 프로젝트 상세보기
 *                                            > 모집중인 프로젝트 > 프로젝트 상세보기
 */
export default {

    props: {
        projectSeq : {},
        tecMberSeq : {}, 
        type : String,
        viewId : String,        // 컴포넌트 호출한 화면ID (프로젝트 수정 페이지로 이동 시 뒤로가기 때문에 필요)
        projectRecrStatus : String,     // 프로젝트 참여 IT프로의 참여 상태 (파트너사 프로젝트현황의 프로젝트 상세에서 사용)
    },

	data() {
		return {		
			projectInfo : {},
			projectRecrFieldList : [],
            projectChoiceCorpList : [],

            nowYyyymmdd : '',

            recrCloseYn : 'N',  // 모집마감 여부
            isBlur : true,  // 비로그인- 모집분야, 업무내용 블러처리
		};
	},
	bforeCreate() {
		// console.log('beforeCreate');
	},
	created() {
		// console.log('created');
	},
	beforeMount() {
		// console.log('beforeMount');
        if(this.$store.state.userInfo.mberSeq){
            this.isBlur = false
        }
	},
	mounted() {
		// console.log('mounted');
        this.nowYyyymmdd = new Date().format("yyyyMMdd");

		this.getProjectInfo();        
	},
	beforeUpdate() {
		// console.log('beforeUpdate');
	},
	updated() {
		// console.log('update');
	},
	beforeDestroy() {
		// console.log('beforeDestroy');
	},
	destroyed() {
		// console.log('destroyed');
	},

	methods: {
		getProjectInfo() {

			var input = {
				projectSeq : this.projectSeq,
                tecMberSeq : this.tecMberSeq,
                type : this.type
			}

			this.$.httpPost('/api/prj/getProjectInfo', input)
				.then(res => {
					// console.log(res.data);
					this.projectInfo 			= res.data.projectInfo;
                    this.projectInfo.projectIndtype = this.projectInfo.projectIndtypeClassCd.substr(0,1);
					this.projectRecrFieldList 	= res.data.projectRecrFieldList;

                    // 모집마감 여부 체크
                    if(this.projectInfo.recrEndYyyymmdd && this.projectInfo.recrEndDateDiff >= 0) {
                        // 모집마감 아님
                        this.recrCloseYn = 'N';
                    } else {
                        // 모집마감
                        this.recrCloseYn = 'Y';
                    }

                    var prjSideInfo = this.projectInfo;
                    if(this.type == '1' || this.type == '5' || this.type == '101' || this.type == '102' || this.type == '103' || this.type == '104'){
                        prjSideInfo.projectRecrFieldList = res.data.projectRecrFieldList;
                        prjSideInfo.recrCloseYn = this.recrCloseYn;
                    }
                    this.$emit('prjSideInfo', prjSideInfo);


                    // 콤마 구분자의 직무분야를 리스트로 변환
					if(this.projectInfo.dutyFieldCont) {
						var tempArr = this.projectInfo.dutyFieldCont.split(',');
						//console.log("tempArr : " + tempArr);
						this.projectInfo.dutyFieldList = [{}];					
						for(var i in tempArr) {
							var test = {};
							this.projectInfo.dutyFieldList.push(test);
							this.projectInfo.dutyFieldList[i].dutyDetail = tempArr[i];
                            this.projectInfo.dutyFieldList[i].dutyFilter = tempArr[i].substr(0,2);
						}
						this.projectInfo.dutyFieldList.pop();
					}

					// window.scroll(0, 0);

                    this.$emit('input', this.projectInfo.projectNm);
				})
				.catch(err => {
					// console.log('============================='); 
					// console.log(err);
					// console.log(err.response);
					// console.log('============================='); 

					alert(err.response.data.error_description);
				});
		},

		clickChangeCorpMgrMberNm() {
			var param = {
				projectSeq : this.projectInfo.projectSeq,
                projectNm : this.projectInfo.projectNm,
			};

			this.$.popup('/dco/gmg/prj/PRJ201P01', param, {width:0, height:0})
				.then(() => {
					this.getProjectInfo();
				})
				// .catch(err => {})
				;
		},

        clickChangeCorpMgrMberNmAdm() {
			var params = {
				projectSeq : this.projectSeq,
                projectNm : this.projectInfo.projectNm,
				corpSeq : this.projectInfo.corpSeq,
                corpNm : this.projectInfo.corpNm,
                				 
                currCorpMgrMberSeq : this.projectInfo.corpMgrMberSeq,    // 현재 클라이언트 프로젝트 담당자
                currCorpMgrMberNm : this.projectInfo.corpMgrMberNm,
                currCorpMgrLoginId : this.projectInfo.corpMgrLoginId,
                
				caller : {
					name: this.$route.name,
					params: this.projectSeq
				}
			}


            var viewNm = 'PRJ910M04';

			// this.$router.push({name: 'PRJ910M04', params });
            this.$router.push({name: viewNm, params });


        },

        clickChangeAgent(gubun) {
           
           var params = {

				projectSeq : this.projectSeq,
				projectNm : this.projectInfo.projectNm,
                currAdmMgrMberSeq : this.projectInfo.admMgrMberSeq,
                currAdmMgrMberNm : this.projectInfo.admMgrMberNm,
                currAdmMgrLoginId : this.projectInfo.admMgrLoginId,
				gubun : gubun,

				caller : {
					name: this.$route.name,
					params: this.input
				}
			}

			this.$router.push({name: 'PRJ910M06', params });
           
        },

		// 프로젝트 수정
		goModifyProject() {
            if(!this.editable) return;

            this.$router.push({name : 'PRJ303M03', query : {projectSeq : this.projectSeq}, params : {caller : { name : this.viewId}}});
		},

        //지원 IT프로 보기
        goAppMber() {
            this.$router.push({name : 'PRJ305M02', params : { projectSeq : this.projectSeq, caller : { name : this.$route.name, params :this.input}}});
        },

        // 관심프로젝트 등록
        insertInterestProject() {

            this.$.popup('/tec/prj/PRJ101P01', { projectSeq : this.projectInfo.projectSeq, projectNm: this.projectInfo.projectNm, gubun: 'insert', recrCloseYn : this.recrCloseYn})
                .then(res => {
                    if(res) {
                        this.getProjectInfo();
                    }
                });
        },

        // 관심프로젝트 삭제
        deleteInterestProject() {

            this.$.popup('/tec/prj/PRJ101P01', { projectSeq : this.projectInfo.projectSeq, projectNm: this.projectInfo.projectNm, gubun: 'delete'})
                .then(res => {
                    if(res) {
                        this.getProjectInfo();
                    }
                });
        },        

        // 프로젝트 지원하기
        insertApp() {
            this.$.popup('/tec/prj/PRJ101P02', { 
                        projectSeq : this.projectInfo.projectSeq, 
                        projectNm: this.projectInfo.projectNm, 
                        projectRecrFieldList: this.projectRecrFieldList, 
                        projectDtlDesc : this.projectInfo.projectDtlDesc,
                        clientNm : this.projectInfo.clientNm,
                        projectLocCont : this.projectInfo.projectLocCont,
                        corpNm : this.projectInfo.corpNm,
                        corpMgrMberNm : this.projectInfo.corpMgrMberNm,
                        gubun: 'insert'})
                .then(res => {
                    //console.log(res);
                    if(res === true) {
                        alert("지원이 완료되었습니다.");
                        this.getProjectInfo();
                    } else if(res == "asgReqFalse") {
                        alert("아직 소속사 신청을 하지 않아 지원을 하실 수 없습니다.\n소속사 신청이 승인된 이후 지원해주세요.");
                    }else if(res == "asgApprFalse") {
                        alert("아직 소속사 승인이 되지 않아 지원을 하실 수 없습니다.\n소속사 신청이 승인된 이후 지원해주세요.");
                    }else if(res == "techGradeFalse") {
                        alert("아직 기술등급이 확정되지 않아 지원을 하실 수 없습니다.\n기술등급이 확정된 이후 지원해주세요.\n※기술등급 확정까지 1일~3일 소요됩니다.");
                    }
                });
        },

        // 프로젝트 지원취소
        // deleteApp() {
        //     this.$.popup('/tec/prj/PRJ101P02', {
        //                 projectSeq : this.projectInfo.projectSeq, 
        //                 projectNm: this.projectInfo.projectNm, 
        //                 projectRecrFieldList: this.projectRecrFieldList, 
        //                 projectAppSeq : this.projectInfo.projectAppSeq,
        //                 gubun: 'delete'})
        //         .then(res => {
        //             if(res) {
        //                 this.getProjectInfo();
        //             }
        //         });
        // },

        // 관리자의 프로젝트 수정
        goAdmModifyProject() {
            if(!this.editable) return;
            var params = {
				caller : {
					name: this.$route.name,
					params: this.input
				}
			}

            this.$router.push({name: 'PRJ910M03', query : {projectSeq : this.projectSeq}, params });
        },

        // 관리자 모집마감 등록, 해제
        // gubun 1:모집마감 상태 (모집마감 해제 처리), 2:모집중상태 (모집마감 등록 처리)
        // recrEndYn : Y 이면 모집마감을 강제로 한 상태
        admRecrEnd(gubun, recrEndYn, projectRecrFieldSeq, workCont, projectRecrStartEndYyyymmdd) {
            if(!this.editable) return;
            if(gubun == '1') {
                if(recrEndYn != 'Y') {
                    alert('모집기간이 종료된 모집분야입니다.\n\n모집마감 해제를 하시려면 프로젝트 수정에서 해당 모집분야의 모집기간을 수정하시기 바랍니다.');    
                    return;
                }
            } 
            
            var param = {
                projectRecrFieldSeq : projectRecrFieldSeq, 
                workCont: workCont, 
                projectRecrStartEndYyyymmdd: projectRecrStartEndYyyymmdd,
                gubun : gubun
            };

            this.$.popup('/adm/prj/PRJ910P01', param)
                .then(res => {
                    if(res) {
                        this.getProjectInfo();
                    }
                });
        },

        // 로그인 화면으로 이동
		pageMove(){
			this.$router.push({name : 'MEM001M01'});
		},
	},
    computed: {
        editable(){
            return this.$store.state.userInfo.mberDivCd == '00'                             //총괄관리자
                || this.$store.state.userInfo.mberSeq == this.projectInfo.admMgrMberSeq     //담당매니저
                || this.$store.state.userInfo.mberSeq == this.projectInfo.corpMgrMberSeq    //클라이언트담당자
        },

    }
};
</script>

